<section class="cards-list">
  @if (!isLoading) {
    <pwj-sorts-bar
      class="cards-list__filter-bar"
      variant="segmented"
      [sorts]="listTabs"
      translateKey="sorting."
      sortParamKey="sort"
      [haveInitializeTab]="false"
      [resultsCount]="productsCount"
      [showFiltersButton]="showFiltersTriggerOnSortBar()"
      (filtersClick)="filtersFromSortBar.emit()"></pwj-sorts-bar>
  } @else {
    <div class="cards-list__sort-bar-skeleton" aria-hidden="true">
      <div class="cards-list__sort-bar-skeleton-inner">
        <ngx-skeleton-loader
          count="1"
          class="cards-list__sort-bar-skeleton-tabs"
          [theme]="{
            width: '100%',
            height: '2.375rem',
            'border-radius': '0.5rem',
            margin: '0',
          }"></ngx-skeleton-loader>
        <div class="cards-list__sort-bar-skeleton-meta">
          <ngx-skeleton-loader
            count="1"
            [theme]="{
              width: '4.5rem',
              height: '0.875rem',
              'border-radius': '0.25rem',
              margin: '0',
            }"></ngx-skeleton-loader>
          @if (showFiltersTriggerOnSortBar()) {
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                width: '2.125rem',
                height: '2.125rem',
                'border-radius': '0.5rem',
                margin: '0',
              }"></ngx-skeleton-loader>
          }
        </div>
      </div>
    </div>
  }

  @if (products && !isLoading) {
    <div>
      @if (productsCount > 0 && products.length > 0) {
        <div>
          <!-- products list -->
          <div class="cards-list__products">
            <ul class="products-list">
              @for (product of products; track product._id) {
                <li>
                  <pwj-product-card
                    [compact]="true"
                    [productCardData]="product"></pwj-product-card>
                </li>
              }
            </ul>
          </div>

          <!-- pagination -->
          @if (productsCount) {
            <pwj-pagination
              [dataCount]="productsCount"
              [perPage]="12"></pwj-pagination>
          }
        </div>
      } @else {
        <div>
          <!-- no content component -->
          <pwj-no-content message="products.noProducts"></pwj-no-content>
        </div>
      }
    </div>
  } @else if (isLoading) {
    <div class="cards-list__products">
      <ul class="products-list">
        <pwj-product-card-skeleton
          [count]="12"
          [compact]="true"
          [wrapInListItem]="true"></pwj-product-card-skeleton>
      </ul>
    </div>
  }
</section>
